import { Link, NavLink } from 'react-router-dom';
import { ThemeToggle } from '../layout/ThemeToggle';
import { useAuth } from '../../lib/auth';
import { Button, Cluster, Inline } from '../ui';

const navItems = [
  { label: 'Features', to: '/features' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Security', to: '/security' }
];

export function PublicHeader(): JSX.Element {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40">
      <Cluster as="div" justify="between" gap={4} className="mx-auto max-w-6xl px-4 py-4 sm:px-6">
        <Link
          to="/"
          className="glass inline-flex items-center rounded-full border border-white/30 px-4 py-2 text-sm font-semibold text-foreground transition hover:shadow-lg dark:border-white/10"
        >
          <Inline gap={3}>
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary to-secondary text-sm font-bold text-white shadow-lg">
              S
            </span>
            <span>DefectSnap</span>
          </Inline>
        </Link>

        <Cluster as="nav" gap={6} className="hidden text-sm font-medium text-muted-foreground md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive
                  ? 'text-foreground underline underline-offset-[10px]'
                  : 'text-muted-foreground hover:text-foreground transition'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </Cluster>

        <Cluster gap={3}>
          <ThemeToggle />
          {user ? (
            <Cluster gap={2}>
              <Link
                to="/app"
                className="btn-glass btn-secondary focus-ring border border-white/40 text-sm font-semibold text-foreground"
              >
                Open app
              </Link>
              {/* Story 2-147xd: left as a direct `Button` — its visual pair
                  above ("Open app") is a router `Link` styled with `.btn-
                  glass`, never a governed control: `ActionDescriptor`'s own
                  header comment (ActionHosts.tsx) deliberately excludes
                  `href`/navigation from the vocabulary — every real host
                  consumer today is a COMMAND. Routing "Sign out" alone
                  through a host would split one visual pair across two
                  different rendering mechanisms for no real gain (a single
                  marketing-chrome sign-out button, not a cluster). */}
              <Button
                variant="ghost"
                onClick={logout}
                className="border border-border text-muted-foreground hover:text-destructive"
              >
                Sign out
              </Button>
            </Cluster>
          ) : (
            <Cluster gap={2} className="text-sm font-medium">
              <Link to="/login" className="text-muted-foreground transition hover:text-foreground">
                Log in
              </Link>
              <Link
                to="/signup"
                className="btn-glass btn-primary focus-ring text-primary-foreground"
              >
                Start free trial
              </Link>
            </Cluster>
          )}
        </Cluster>
      </Cluster>
    </header>
  );
}
